import { render, staticRenderFns } from "./MainFramework.vue?vue&type=template&id=3c102578&scoped=true"
import script from "./MainFramework.vue?vue&type=script&lang=js"
export * from "./MainFramework.vue?vue&type=script&lang=js"
import style0 from "./MainFramework.vue?vue&type=style&index=0&id=3c102578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c102578",
  null
  
)

export default component.exports